import React from 'react';
import { Outlet } from 'react-router-dom';
import AdminSidebar from '../pages/AdminSidebar';
import './AdminLayout.css'; // Criaremos este arquivo a seguir

const AdminLayout = () => {
  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <AdminSidebar />
      </div>
      <div className="admin-content">
        <div className="admin-content-inner">
          <Outlet /> {/* As páginas como Dashboard, Clínicas, etc., serão renderizadas aqui */}
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;